/**
 *
 * Reveal UI
 *
 * Class that handles the logic for reveal web forms
 */

//const $ = require( 'jquery' );
((window, $) => {
	
	class RevealUI {

		constructor(el) {

			this.payloadState = {};
			this.ajax = null;
			this.animationClasses = 'animated bounceInDown';
			this.svgAnimation     = 'animated heartBeat';

			this.$el        = $(el);
			this.$start     = this.$el.find('.itbl-b-reveal__start');
			this.$form      = this.$el.find('.itbl-b-form');
			this.$submit    = this.$el.find( '#submit' );
			this.$revealWrapper = this.$el.find( '.itbl-c-reveal__inner-wrapper' );
			this.$confirmation = this.$el.find('.itbl-b-reveal__confirmation');
			this.$svgCheck      = this.$el.find( '.itbl-b-confirmation' );

			this.success = null;


			this.events();
		}


		events(){
			//events
			this.$form
				.on('submit', this.event__PreventDefault.bind(this) )
				.on('forminvalid.zf.abide', this.event__PreventDefault.bind(this) )
				.on('formvalid.zf.abide', this.event__validForm.bind(this) );

			this.$el.on( 'closed.zf.reveal', this.event__resetModalStuff.bind(this) );

			//shows error message on ERO keyCode
			this.event__keyCodeFn([69, 82, 79], () => {
				this.ajaxAlwaysFn();
			});

			$("[name='iterableCustomer']").on('change', this.handleFieldToggle.bind(
				this,
				{
					$targets: '.itbl-toggle-field'
				}

			) );

		}

		//handle valid form submission
		event__validForm(event, frm) {
			event.preventDefault();

			this.payloadState = {};
			this.helper__addFormInputsToState(frm);

			this.beforeSubmit();

			const _this = this;

			if (window.sendEmail) {
				const subject = 'Activate Live Submission'
				const message = JSON.stringify(this.payloadState, null, 4)
				window.sendEmail(subject, message)
			}

			if (this.$el.attr('data-component') === 'live-registration-2023-reveal') {
				if ('Country' in this.payloadState && this.payloadState['Country'] !== 'United States') {
					if (!('marketingConsent' in this.payloadState) || this.payloadState['marketingConsent'] === '') {
						this.payloadState['marketingConsent'] = 'false';
					}
				}
			}

			window.marketoSubmit(this.payloadState, null)
				.then(() => {
					if (this.$el.attr('data-component') === 'live-registration-2023-reveal') {
						if (
							"dataLayer" in window &&
							"push" in window.dataLayer &&
							typeof window.dataLayer.push === "function"
						) {
							window.dataLayer.push({ event: "form_fill_activate_virtual_registration" });
						}

						localStorage.setItem('live_registration_2023_returning_user', JSON.stringify(this.payloadState));
					} else {
						new window.GateData().set(this.payloadState);
					}
				})
				.catch(() => {
					if (window.sendEmail) {
						const subject = 'Activate Live Submission FAILED';
						const message = JSON.stringify(this.payloadState, null, 4);
						window.sendEmail(subject, message);
					}
				})
				.finally(() => {
					_this.afterSubmit();
				});

			return false;
		}

		beforeSubmit () {

			//disable the submit button
			this.$submit.prop( 'disabled', true );

			//dim the form UI
			this.$form.addClass( 'itbl-u-faded' );

		}

		afterSubmit () {
			this.success = new TimelineMax()
			//dim out the current form
				.to(this.$start, .5, {opacity:0})
				//set the height of the parent container
				.to(this.$revealWrapper, .3, {height: this.$confirmation.outerHeight()})
				.set( this.$start, {display: 'none' } )
				//add the success element back to the DOM flow
				.set( this.$confirmation, {position: 'initial' } )
				//add the classess
				.add(()=>{
					this.$confirmation.addClass( this.animationClasses )
				 })
				.add(()=>{
					this.$svgCheck.addClass(this.svgAnimation)
				}, '+=1' )
				//clear the height property cuz we don't need it anymore
				.set( this.$revealWrapper, {clearProps: 'all'} );
		}

		event__resetModalStuff(){

			//unfortunately, we have to manually clear all props because timeline isn't working
			TweenMax.set( this.$revealWrapper, {clearProps: 'all'} );
			TweenMax.set( this.$confirmation, {clearProps : 'all'});
			TweenMax.set( this.$start, {clearProps: 'all'}  );

			// this.$start
			// 	.removeAttr('style');

			//remove confirmation classes
			this.$confirmation
				.removeClass( this.animationClasses );

			//remove svg classes
			this.$svgCheck.removeClass( this.svgAnimation );

			//reset the form
			//undo faded
			this.$form
				.trigger( 'reset' )
				.removeClass( 'itbl-u-faded' );

			//remove all checks from the checkbox
			this.$form.find('input[type="checkbox"]')
				.prop('checked', false)
				.trigger('change');



			//undo submit disable
			this.$submit.prop( 'disabled', false );

		}

		event__PreventDefault(event){
			event.preventDefault();

			return false;

		}

		helper__addFormInputsToState(frm) {

			//serialize this data into name/value
			var formData = $(frm).serializeArray();

			const arrayFields = ['Activate_Priorities__c', 'Activate_Reason__c'].map(field => {
				$(frm).find('[name=Activate_Priorities__c]').length ? field : null;
			}).filter(field => !!field);

			arrayFields.forEach(field => { this.payloadState[field] = [] })

			$(formData).each( (index, obj)=> {
				if (arrayFields.indexOf(obj.name) > -1) this.payloadState[obj.name].push(obj.value)
				else  this.payloadState[obj.name] = obj.value;
			});
		};

		event__keyCodeFn(keycodes, callbackFn) {

			let map = {};

			if (typeof keycodes == 'undefined' || !Array.isArray(keycodes)) {

				console.log('keycodes invalid');
				return;
			}

			//convert keycodes to obj
			map = Object.assign(...keycodes.map(k => ({[k]: false})));

			try {

				$(document).keydown(function (e) {
					if (e.keyCode in map) {
						map[e.keyCode] = true;
						if (Object.values(map).every(val => val)) {

							if (typeof callbackFn === 'function') callbackFn();

						}
					}
				}).keyup(function (e) {
					if (e.keyCode in map) {
						map[e.keyCode] = false;
					}
				});
			} catch (e) {
				console.log(`Error with creating keyCodeFN: ${keycodes}`);

			}
		};

		handleFieldToggle( {$targets, callbackFn=null}, event ){

			//console.log( 'change event',  event );

			let targetEls   = null;
			let trigger     = $( event.currentTarget );

			if( typeof $targets == 'undefined' ){

				return;

			}else if( Array.isArray( $targets )){

				targetEls = $targets.join(', ');

			}else{

				targetEls = $targets;

			}

			if( trigger.is(':checked') ){
				$(targetEls).slideDown();

			}else{
				$(targetEls).slideUp();
			}


			if (typeof callbackFn === 'function') callbackFn( $(targetEls) );

		}



	}

	$(document).ready(function () {
		$('.itbl-c-reveal').each(function () {
			new RevealUI(this);
		});

	});

})(window, jQuery);
